import { handleActions } from 'redux-actions'

const getDefaultState = () => ({
  steps: [
    { label: 'Servizi', url: '/' },
    { label: 'Giorno e ora', url: '/seleziona-data' },
    { label: 'I tuoi dati', url: '/inserimento-dati' }
  ]
})

export const reducer = handleActions({}, getDefaultState())
